(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["module-shop-by-brand"] && !Shopify.designMode) return;
  try {
    

const brandNames = document.querySelectorAll('[data-brand-name]');

brandNames.forEach(brandName => {
  brandName.addEventListener('mouseover', (e)=>{

    document.querySelector('[data-brand-name].active').classList.remove('active')
    brandName.classList.add('active');

    let imageSrc = brandName.dataset.src;
    let brandImage =  document.querySelector('img.brand_image_tag');
    brandImage.src = imageSrc;
    brandImage.srcset = imageSrc;

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-brands"] && !Shopify.designMode) return;
  try {
    
  const brandLinks = document.querySelectorAll('[data-size] [data-brandlist]');
  brandLinks.forEach(link => {
    link.addEventListener('click', () => {
      document.querySelector('.active[data-brandlist]').classList.remove('active');
      link.classList.add('active');
      document.querySelector('[data-open]').removeAttribute('data-open');
      document.querySelector(`.brand-container[data-brandlist="${link.getAttribute('data-brandlist')}"]`).setAttribute('data-open', '');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
  window.addEventListener("DOMContentLoaded", () => {
    const faqLinks = document.querySelectorAll('[data-faq-menu]');
    faqLinks.forEach(link => {
      const anchor = link.getAttribute('href');
      link.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
          top: document.querySelector(anchor).offsetTop,
          behavior: 'smooth'
        });
      })
    });

    const elFaqContainer = document.querySelector(".js-faq-container");
    const elFirstSection = document.querySelectorAll('.js-faq-section')[0];
    elFirstSection.classList.add('first');
    elFirstSection.style.marginTop = `-${elFaqContainer.getBoundingClientRect().height}px`
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  const pwdBtn = document.querySelectorAll('[data-enter-site-password]');
  pwdBtn.forEach(btn => {
    btn.addEventListener("click", () => {
      document.querySelector('[data-storefront-password-screen]').style.display = 'block';
    });
  })

  const closeBtn = document.querySelector('.close');
  closeBtn.addEventListener("click", () => {
    document.querySelector('[data-storefront-password-screen]').style.display = 'none';
  });
  document.querySelector('body').style.opacity = 1;


  } catch(e) { console.error(e); }
})();
})();
